export const TRAVEL_LIST_SCHEMA_URL = 'https://withjoy.com/assets/public/schemas/travelSchemaV1_0_0.json' as const;
export const TRAVEL_LIST_COMPONENT_TYPE = 'TravelList' as const;
